var exports = {
  "hS": "ForwardModal.module__richInput___cHNJWV",
  "NG": "ForwardModal.module__footerSection___cHNJWV",
  "vm": "ForwardModal.module__messageInputContainer___cHNJWV",
  "hj": "ForwardModal.module__messageInputContainerDisabled___cHNJWV",
  "zt": "ForwardModal.module__messageInputContainerWithCounter___cHNJWV",
  "pn": "ForwardModal.module__messageInputContainerWithNotice___cHNJWV",
  "XK": "ForwardModal.module__slowmodeNotice___cHNJWV",
  "X8": "ForwardModal.module__messageInputActions___cHNJWV",
  "Vr": "ForwardModal.module__emojiPickerButton___cHNJWV",
  "Z8": "ForwardModal.module__emojiPickerButtonActive___cHNJWV",
  "mI": "ForwardModal.module__emojiIcon___cHNJWV",
};

module.exports = exports;
